var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9423 16.2904C4.63908 16.2904 1.15063 12.8019 1.15063 8.4987C1.15063 4.19548 4.63908 0.707031 8.9423 0.707031C13.2455 0.707031 16.734 4.19548 16.734 8.4987C16.734 12.8019 13.2455 16.2904 8.9423 16.2904ZM8.9423 14.873C12.4631 14.873 15.3173 12.0188 15.3173 8.498C15.3173 4.97718 12.4631 2.123 8.9423 2.123C5.42148 2.123 2.5673 4.97718 2.5673 8.498C2.5673 12.0188 5.42148 14.873 8.9423 14.873ZM11.2751 5.87292L7.52601 9.62205L5.90188 7.99792L4.90014 8.99966L7.52601 11.6255L12.2769 6.87466L11.2751 5.87292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.dd2e04f9e109d5c2af92637adf9114dd.svg";
export { ForwardRef as ReactComponent };